import React from 'react'
import cn from 'classnames'
import { PostOrPage } from '@tryghost/content-api'
import {
  IStreamingVideo,
  TConfigurableColorOldBranding,
  TConfigurableTitleSize,
} from 'app/_components/ContentfulPage/contentfulPage.types'
import { useInView } from 'react-intersection-observer'
import { useToggleResponsiveContent } from '@utils/responsiveness/breakpoints'
import { InTheWildDesktop } from './desktopView/InTheWildDesktop'
import { InTheWildMobile } from './mobileView/InTheWildMobile'
import { ComponentPlaceholder } from 'app/_components/ContentfulPage/ComponentPlaceholder'
import { mapTextColorToClass } from 'app/_components/ContentfulPage/ConfigurableText/ConfigurableText.utils'
import { titleSizeToClass } from 'app/_components/ContentfulPage/contentfulPage.utils'

export interface IInTheWild {
  id?: string
  componentKey?: string
  submenuLabel?: string
  className?: string
  children?: any
  title?: string
  titleSize?: TConfigurableTitleSize
  titleColor?: TConfigurableColorOldBranding
  subtitle?: string
  subtitleColor?: TConfigurableColorOldBranding
  description?: string
  wildImg?: string
  posts: Partial<PostOrPage>[] | []
  streamingVideos?: IStreamingVideo[]
  generateStatically?: boolean
}
const PLACEHOLDER_HEIGHT = 850

export function InTheWild({
  title = 'noissue in the Wild',
  titleSize = 'L',
  titleColor = 'purple',
  subtitle,
  subtitleColor = 'grey',
  description = 'Need some inspiration? #noissue',
  wildImg,
  posts,
  className,
  streamingVideos,
  generateStatically = false,
}: IInTheWild) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '100px 0px',
  })

  const inTheWildContent = useToggleResponsiveContent({
    breakpoint: 'md',
    desktopContent: <InTheWildDesktop posts={posts} videos={streamingVideos} />,
    mobileContent: <InTheWildMobile posts={posts} videos={streamingVideos} />,
  })

  return (
    posts &&
    posts.length !== 0 && (
      <section
        className={cn('py-[32px]', className)}
        style={{
          background: `${
            wildImg ? `url(${wildImg})` : ''
          } center top / 90% no-repeat rgb(255, 255, 255)`,
        }}
        ref={ref}
      >
        {generateStatically || inView ? (
          <div className="max-w-[1300px] w-full md:px-4 m-auto">
            {subtitle && (
              <h4
                className={`text-center text-[12px] leading-tight mb-4 mx-auto mt-4 ${mapTextColorToClass[subtitleColor]}`}
              >
                {subtitle}
              </h4>
            )}
            {title && (
              <h2
                className={`flex md:flex-row flex-col w-full font-bold md:justify-center text-center items-center md:leading-tight leading-snug px-8 ${
                  description ? 'mb-6 sm:mb-6' : 'mb-24'
                } ${!subtitle ? 'mt-4 sm:mt-6' : ''} ${
                  titleSizeToClass[titleSize] || titleSizeToClass.L
                } ${
                  mapTextColorToClass[titleColor] || mapTextColorToClass.purple
                }`}
              >
                {title}
              </h2>
            )}
            {description && (
              <p className="text-core-grey-90 text-[14px] leading-snug text-center mb-16 px-8">
                {description}
              </p>
            )}
            {inTheWildContent}
          </div>
        ) : (
          <ComponentPlaceholder height={PLACEHOLDER_HEIGHT} />
        )}
      </section>
    )
  )
}

export default InTheWild
